import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Btn from "../../../Components/Ui_elements/Btn";
import TextFieldComponent from "../../../Components/TextFieldComponent";
import { CreateClientAccount, GetNumber, UpdateClientAccount } from "../../../redux/Thunk/ClientModule/ClientThunk";
import { useNavigate } from "react-router-dom";

const AccountForm = ({ initialData = null, closeForm }) => {
  const { numberAscending } = useSelector((state) => state.root.ClientModule);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState(
    initialData || { vUserName: "", vWebsite: "", notes: "", fileId: "", vClientNumber: numberAscending } // Todo fileId
  );
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(GetNumber());
  }, [dispatch]);

  // Update formData whenever numberAscending changes
  useEffect(() => {
    if (!initialData) {
      setFormData((prevData) => ({
        ...prevData,
        vClientNumber: numberAscending,
      }));
    }
  }, [numberAscending, initialData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData?.vUserName.trim()) newErrors.vUserName = "Account Name is required";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (initialData) {
      dispatch(UpdateClientAccount({ navigate, formData }));
    } else {
      dispatch(CreateClientAccount(formData)).then(() => {
        closeForm();
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} >
      <Grid container spacing={2} sx={{ p: 2, background: "#fff" }}>
        <Grid item xs={12} sm={6}>
          <TextFieldComponent
            type="text"
            name="vUserName"
            label="Account Name"
            value={formData.vUserName}
            onChange={handleInputChange}
            error={errors.vUserName || ""}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextFieldComponent
            type="text"
            name="vWebsite"
            label="Website"
            value={formData.vWebsite}
            onChange={handleInputChange}
            isNotMandatory={true}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextFieldComponent
            type="text"
            name="notes"
            label="Notes"
            value={formData.notes}
            onChange={handleInputChange}
            fullWidth
            multiline
            rows={3}
            isNotMandatory={true}
          />
        </Grid>
        <Grid item xs={12}>
          <Btn type="submit">{initialData ? "Update" : "Add"}</Btn>
        </Grid>
      </Grid>
    </form>
  );
};

export default AccountForm;
